export interface Scroll {
  direction: string;
  power: number;
}

export class Move {
  // Scroll Helper
  private static lastScrollTop: number = 0;
  public static scroll: Scroll = {direction: 'none', power: 0};

  public static init(){
    Move.directionEvents();
  }

  private static directionEvents() {
    $(window).on('scroll', function (event: Event) {
      const st = $(this).scrollTop();
      const scrollPower = st - Move.lastScrollTop;
      Move.scroll = {
        direction: (scrollPower > 0) ? 'down' : 'up',
        power: st - Move.lastScrollTop
      };
      Move.lastScrollTop = st;
    });
  }

}